<template>
  <!--copied from MyTable.vue-->
  <div class="container">
    <table class="myTable">
      <col v-for="(val, key) in columnWidths" :style="`width:${val}%;`" :key="key" />
      <thead>
        <tr>
          <th v-for="field in header" v-bind:key="field.name" :class="field.class">
            {{ field.name }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(pile, index) in piles" :key="index">
          <TableCellListbox
            :options="pileTypeDisplayOptions"
            :displayOptions="pileTypeDisplayOptions"
            v-model:selected="pile.pileType"
          >
          </TableCellListbox>

          <TableCellInput
            :placeHolder="'input pile count'"
            :type="'number'"
            v-model="pile.pileCount"
          >
          </TableCellInput>

          <TableCellInput
            :placeHolder="'input min torque'"
            :type="'number'"
            v-model="pile.torqueMin"
          >
          </TableCellInput>

          <TableCellInput
            :placeHolder="'input max torque'"
            :type="'number'"
            v-model="pile.torqueMax"
          >
          </TableCellInput>

          <TableCellButton :name="'Delete Row'" :buttonClass="'delete-btn'" @clicked="deleteRow(index)">
          </TableCellButton>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="form-btns">
    <FormBtn @clicked="addRow" :name="'Add Row'"></FormBtn>
  </div>
</template>

<script setup lang="ts">
import { FormBtn } from '@/components/form'
import type { PostechPile, PileType } from '@/types/types'
import { usePostechStore, usePileStore } from '@/stores'
import { TableCellListbox, TableCellInput, TableCellButton } from '@/components/table'
import { storeToRefs } from 'pinia'

const header = [
  { name: 'pileType', class: 'col-span-3' },
  { name: 'pileCount', class: 'col-span-1' },
  { name: 'torqueMin', class: 'col-md-2' },
  { name: 'torqueMax', class: 'col-md-2' },
  { name: 'delete', class: 'col-md-2' }
]
const columnWidths = [60, 10, 10, 10]

//const pilesHeader = ['pileType', 'pileCount', 'torqueMin', 'torqueMax'];
const postech = usePostechStore()
const pileStore = usePileStore();
const { allPiles } = storeToRefs(pileStore);
//const pileTypeOptions = await postech.getAllPileTypes()
const pileTypeDisplayOptions = allPiles.value.map((piletype : PileType) => {
  //return `${piletype.manufacturer} ${piletype.type} (${piletype.od_in}")`;
  return piletype.name
})

const piles = defineModel<Array<PostechPile>>('piles', { required: true })

/**
 * Adjust the index nos
 * @param {Number} index
 */
function deleteRow(index: number) {
  console.log('deleteRow for index : ' + index)
  piles.value.splice(index, 1)
}

/**
 * only add up to 6 total rows
 */
function addRow() {
  console.log('Invoice-table.addRow()..')
  //if (rowCount.value < maxRows) {
  piles.value.push({ pileType: null, pileCount: null, torqueMax: null, torqeMin: null })
  // }//else{
  //    addBtnDisabled.value=true;
  //}
}
</script>

<style lang="css" scoped>
.form-btns {
  margin-top: 1rem;
  margin-bottom: 1rem;
  /*  display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: center;*/
}
</style>
